import type { ChainDataProvider } from '@polaris/core/models'
import { getQueryClient } from '@/src/configs/tanstack-query'
import {
  cosmosRegistryChainQuery,
  evmRegistryChainQuery,
} from '@/src/queries/keys/chains'

export const webChainDataProvider = {
  async getCosmosChain(chainId: string) {
    return getQueryClient().ensureQueryData(
      cosmosRegistryChainQuery({ chainId }),
    )
  },

  async getEvmChain(id: string) {
    return getQueryClient().ensureQueryData(evmRegistryChainQuery({ id }))
  },
} satisfies ChainDataProvider
